import AutomaticAuthorizationScheduler from ".";

export const automaticAuthorizationSchedulerRoutes = [
  {
    path: "/automaticAuthorizationScheduler",
    element: <AutomaticAuthorizationScheduler />,
  },
];
